/**
 * Period Selector Component
 *
 * Time period selector buttons for the performance chart.
 */

import { cn } from "@/lib/utils";
import { TIME_PERIODS } from "../constants";
import type { TimePeriod } from "../types";

interface PeriodSelectorProps {
  selected: TimePeriod;
  onChange: (period: TimePeriod) => void;
}

/**
 * Time period selector buttons
 */
export function PeriodSelector({ selected, onChange }: PeriodSelectorProps) {
  return (
    <div className="flex gap-1 bg-muted rounded-lg p-1">
      {TIME_PERIODS.map((period) => (
        <button
          key={period}
          onClick={() => onChange(period)}
          className={cn(
            "px-3 py-1 text-xs font-medium rounded-md transition-colors",
            selected === period
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {period}
        </button>
      ))}
    </div>
  );
}
